import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment } from 'react';
import styles from '~/src/lib/styles.json';
import { imgIconGoldenTicketSvg } from '../../images';
import { colorFromInt } from '../../lib';
import { Urls } from '../../lib/enums/urls';
import { Ot7Division } from '../../models/Ot7Division';
import { Ot7Event } from '../../models/Ot7Event';
import { Ot7Game } from '../../models/Ot7Game';
import { Ot7Team } from '../../models/Ot7Team';
import useFetch from '../../overtime-lib/src/www/hooks/useFetch';
import TBD from '../TBD';
import './PowerRankingsTable.scss';

const PowerRankingsTable = () => {
	const fetchResult = useFetch<Ot7Team[]>({
		url: `${Urls.RestApiBaseUrl}/ot7_teams/v1/public`,
		key: 'ot7_teams',
	});

	const teams = fetchResult.result.read();

	const divisionsResult = useFetch<Ot7Division[]>({
		url: `${Urls.RestApiBaseUrl}/ot7_divisions/v1/public`,
		key: 'ot7_divisions',
	});

	const divisions = divisionsResult.result.read();

	type teamStanding = Partial<Ot7Team> & {
		position: number;
		wins: number;
		losses: number;
		draws: number;
		direction: 'up' | 'down' | 'stay';
		shift: number;
	};

	type standingsResult = { ot7_event: Ot7Event; ot7_games: Ot7Game[]; ot7_teams: teamStanding[] };

	const powerRankings: teamStanding[] = [
		{
			id: '34e8eb25-abcc-4307-9b02-4f4188c6ee6c',
			name: 'Lo-Pro',
			position: 1,
			wins: 9,
			losses: 1,
			draws: 0,
			direction: 'stay',
			shift: 0,
		},
		{
			id: '813986d0-bf96-4384-8b02-52cafe4910b7',
			name: 'SFE',
			position: 2,
			wins: 8,
			losses: 2,
			draws: 0,
			direction: 'stay',
			shift: 0,
		},
		{
			id: 'e73a9119-e136-40a5-9e73-1ac623264b3f',
			name: 'Trillion Boys',
			position: 3,
			wins: 7,
			losses: 2,
			draws: 0,
			direction: 'stay',
			shift: 0,
		},
		{
			id: '9be30b26-5936-48b9-b56e-d6456e25dab0',
			name: 'C1N',
			position: 4,
			wins: 6,
			losses: 4,
			draws: 0,
			direction: 'stay',
			shift: 0,
		},
		{
			id: '3afec11d-a93a-46ee-8af5-d763fb6f69eb',
			name: 'Raw Miami',
			position: 5,
			wins: 6,
			losses: 4,
			draws: 0,
			direction: 'stay',
			shift: 0,
		},
		{
			id: '17719c9a-3445-439c-a0d7-5e66a4e5b7cc',
			name: 'Level82',
			position: 6,
			wins: 7,
			losses: 3,
			draws: 0,
			direction: 'up',
			shift: 9,
		},
		{
			id: '9068a093-d14e-4ca0-8540-867312db815f',
			name: 'Midwest Boom',
			position: 7,
			wins: 5,
			losses: 5,
			draws: 0,
			direction: 'down',
			shift: 1,
		},
		{
			id: '14c0e06b-2fe4-4fc5-828b-adf529c08e03',
			name: 'Tucson Turf',
			position: 8,
			wins: 6,
			losses: 4,
			draws: 0,
			direction: 'up',
			shift: 1,
		},
		{
			id: 'f5b65194-efcc-43de-b6c6-935a9c3b91be',
			name: 'California Power',
			position: 9,
			wins: 5,
			losses: 5,
			draws: 0,
			direction: 'down',
			shift: 2,
		},
		{
			id: '589b5726-c4bc-4111-b5c2-91502a2c729a',
			name: 'Cold Hearts',
			position: 10,
			wins: 4,
			losses: 6,
			draws: 0,
			direction: 'up',
			shift: 4,
		},
		{
			id: 'becfd755-be64-4c08-acf5-cd4cce0c3779',
			name: 'Hellstar',
			position: 11,
			wins: 4,
			losses: 6,
			draws: 0,
			direction: 'down',
			shift: 1,
		},
		{
			id: '4db4a9c4-d442-49fa-b43e-3b1c27be4507',
			name: 'Team Toa',
			position: 12,
			wins: 3,
			losses: 7,
			draws: 0,
			direction: 'up',
			shift: 6,
		},
	];

	return (
		<div className="PowerRankingsTable">
			<div className="TeamsContainer">
				<div />
				<div>Team</div>
				{/* <div>W</div>
				<div>L</div> */}
				<div className="Direction">
					<div className="Arrow">R</div>
				</div>
				{true ? (
					powerRankings.map((t, i) => {
						const team = teams.find((team) => t.id == team.id);
						const division_won = divisions?.find((d) => d.winner_ot7_team_id == t.id);
						const isDivisionWinner = !!division_won;
						const isGoldenTicketWinner = division_won?.slug == 'golden-ticket';

						return (
							<Fragment key={t.id}>
								<div className={`Position Row-${i + 1}`}>{(t.position ?? 0) || '-'}</div>
								<div className={`Name Row-${i + 1}`}>
									<a className="inherit" href={`/teams/${t.id}`}>
										<div className="TeamLogo" style={{ backgroundColor: colorFromInt(team?.primary_color) }}>
											<img src={`${Urls.OvertimeImagesBaseUrl}/${team?.logo_path}`} />
										</div>
										{t.name}
										{isDivisionWinner && (
											<div className="Winner">
												{isGoldenTicketWinner && <img src={imgIconGoldenTicketSvg} alt="Golden Ticket" />}
												{!isGoldenTicketWinner && (
													<FontAwesomeIcon icon={faTrophy} style={{ color: styles.COLOR.BRAND_PRIMARY }} />
												)}
											</div>
										)}
									</a>
								</div>
								{/* <div className={`Row-${i + 1}`}>{t.wins ?? 0}</div>
								<div className={`Row-${i + 1}`}>{t.losses ?? 0}</div> */}
								<div className={`Row-${i + 1} Direction Direction-${t.direction}`}>
									<div className="Arrow">
										{t.direction == 'stay' ? '—' : t.direction == 'up' ? '↑' : t.direction == 'down' ? '↓' : ''}
										{t.shift > 0 && <div className="Shift">{t.shift}</div>}
									</div>
								</div>
							</Fragment>
						);
					})
				) : (
					<TBD />
				)}
			</div>
		</div>
	);
};

export default PowerRankingsTable;
